// 🎯 Página principal para recepcionar devoluciones - Main page for receiving returned items
import { useParams } from 'react-router-dom';
import { ReceiveContainer } from './components/containers/ReceiveContainer';

export const Receive = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>ID no válido</div>;
  }

  return <ReceiveContainer returnedId={parseInt(id, 10)} />;
};

export default Receive;
